export default __webpack_public_path__ + "static/context-dont-1-7af00c28e84628dfc61ab2aa8c371312.png";